import { memo } from "react";
import { enterExplore } from "../../utils/common";

/* 사이트 내용 시작하는 버튼 */
const ExploreBtn = () => {
  return (
    <div className="btn-area">
      <button
        onClick={() => {
          enterExplore();
        }}
        className="btn explore"
      >
        <span>explore</span>
      </button>
    </div>
  );
};

export default memo(ExploreBtn);
